export default theme => ({
  headerIcon: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    width: 32,
    height: 32,
    marginRight: 10
  }
});